var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeader2ShapeA(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Asset 4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46",
    d: "M1690.82 719c-95.48 0-188.15-6.93-275.37-20.65a1481 1481 0 01-204.82-47c-147.3-45.34-253-103.86-355.3-160.44-68.16-37.73-132.55-73.36-203.21-101-78.75-30.81-155-47.7-240-53.14a898.989 898.989 0 00-57.21-1.82c-111.5 0-226.15 20.78-340.77 61.78l-14.14 5V0h1920v706.7l-8.58.85q-109.93 11.24-220.57 11.45z",
    fill: "#e4e8f1"
  }))))));
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIwIDEwODAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7b3BhY2l0eTowLjQ7fS5jbHMtMntmaWxsOiNlNGU4ZjE7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJBc3NldF80IiBkYXRhLW5hbWU9IkFzc2V0IDQiIGNsYXNzPSJjbHMtMSI+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBpZD0iUGF0aF80NiIgZGF0YS1uYW1lPSJQYXRoIDQ2IiBjbGFzcz0iY2xzLTIiIGQ9Ik0xNjkwLjgyLDcxOWMtOTUuNDgsMC0xODguMTUtNi45My0yNzUuMzctMjAuNjVhMTQ4MSwxNDgxLDAsMCwxLTIwNC44Mi00N2MtMTQ3LjMtNDUuMzQtMjUzLTEwMy44Ni0zNTUuMy0xNjAuNDQtNjguMTYtMzcuNzMtMTMyLjU1LTczLjM2LTIwMy4yMS0xMDEtNzguNzUtMzAuODEtMTU1LTQ3LjctMjQwLTUzLjE0LTE4Ljg5LTEuMjEtMzguMTQtMS44Mi01Ny4yMS0xLjgyLTExMS41LDAtMjI2LjE1LDIwLjc4LTM0MC43Nyw2MS43OEwwLDQwMS43M1YwSDE5MjBWNzA2LjdsLTguNTguODVRMTgwMS40OSw3MTguNzksMTY5MC44NSw3MTlaIi8+PC9nPjwvZz48L2c+PC9zdmc+";
export { SvgHeader2ShapeA as ReactComponent };